import React from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import Card from '../../../../../muiComponents/Card';
import StatusIndicator from './StatusIndicator';
import ChangeStatusButton from './ChangeStatusButton';
import { useZitoneoServices } from '../../../contexts/ZitoneoContentContext';
import { STATUS_KEYS } from '../../../utils/zitoneoServicesUtils';

const StatusSection = () => {
    const translate = useTranslate();
    const { ZitoneoPublishStatusKey } = useZitoneoServices();
    return (
        <div className='hotel-content-settings__section'>
            <div className='settings-section__header'>
                <h5 className='settings-section__title'>
                    {translate('publication_status')}
                </h5>
                <p className='settings-section__description'>
                    {translate('publication_status_description')}
                </p>
            </div>
            <Card className='padding20 flex flex-between'>
                {ZitoneoPublishStatusKey === STATUS_KEYS.NOT_STARTED ? (
                    <p>{translate('save_first_status')}</p>
                ) : (
                    <>
                        <StatusIndicator isLoading={false} />
                        <ChangeStatusButton isLoading={false} />
                    </>
                )}
            </Card>
        </div>
    );
};

export default StatusSection;
